import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'
import { DealContract } from 'modules/domain/deal/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { AButton } from 'views/components/Analytics'
import { CompletedStatus } from 'views/components/CompletedStatus/CompletedStatus'
import { StatusesRightArrow } from 'views/components/StatusesRightArrow/StatusesRightArrow'
import { StatusBlockWrapper } from 'views/styled/common'

type Props = {
  contract: DealContract
  onSuccess: refetchFunc
}

export const ChangeStatusControl = ({ contract, onSuccess }: Props) => {
  const { t } = useTranslation('contracts')
  const { id } = useParams()

  const [updateStatusProgress, updateStatus] = useAProgress(
    (status: string) =>
      apiClient.post(endpoints.dealContractChangeStatus(id), {
        new_status: status,
      }),
    {
      eventName: 'dealContractChangeStatuses',
      onSuccess: () => onSuccess(true),
    },
  )
  const nextStatus = contract.available_statuses[0]

  return (
    <>
      {nextStatus ? (
        <StatusBlockWrapper>
          <div>{t(`table.statuses.${contract.status}`)}</div>
          <StatusesRightArrow />
          <AButton
            id={nextStatus}
            color="secondary"
            onClick={() => updateStatus(nextStatus)}
            progress={updateStatusProgress}
          >
            {t(`table.statuses.${nextStatus}`)}
          </AButton>
        </StatusBlockWrapper>
      ) : (
        <CompletedStatus />
      )}
    </>
  )
}
